import * as actionTypes from 'constants/ActionTypes';
import helpers from 'helpers';
import moment from 'moment';
import _ from 'lodash';

const vesselPositions = (state = {
    items: [],
    isLoaded: false,
    searchText: '',
    from: '',
    until: '',
}, action) => {
    switch (action.type) {
        case actionTypes.GET_STATISTICS_VESSEL_POSITIONS.REQUEST:
            return {
                ...state,
            };
        case actionTypes.GET_STATISTICS_VESSEL_POSITIONS.SUCCESS: {
            return {
                ...state,
                items: action.data,
                isLoaded: true,
            };
        }
        case actionTypes.GET_STATISTICS_VESSEL_POSITIONS.FAILURE:
            return {
                ...state,
                isLoaded: true,
            };
        default:
            return state;
    }
};

export default vesselPositions;



// WEBPACK FOOTER //
// ./app/reducers/statistics/vesselPositions.js